module.exports = __webpack_public_path__ + "img/2x.009bf54.jpg";